import styled from 'styled-components';

const SubLabel = styled.span`
    font-weight: 600;
`;

export default SubLabel;